import createRequestRequest from "../helpDesk/createRequestRequest";
import {request} from "../../../../../res/rest/restRequest";
import JSZip from "jszip";
import {env} from "../../../../../res/config/env";
import HttpClient from "../../../http/HttpClient";
import {api} from "../../../../../res/rest/api";

const newProductRequest = () => {

    const builder = {};

    builder.data = (data) => {
        builder.reqData = data;
        return builder;
    }

    builder.imgData = (imgData) => {
        builder.imgData = imgData;
        return builder;
    }

    const sendRequest = async (session, name, code) => {
        const req = createRequestRequest()
            .setSummary("New product request. Product name: " + name + ", Code: " + code)
            .setRequestTypeID(1000051)
            .setRoleID(1000102)
            .setConfidentialityType("I")
            .setPriority("3");

        await req.sendIt(session);
    }

    const getImportData = (session) => {
        const i = builder.reqData;
        return {
            "C_BPartner_ID": session.bPartnerID,
            "BPartner_Value": session.businessCode,
            "Description": i.Name,
            ...i
        }
    }

    const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64data = reader.result.split(",")[1]; // Remove the "data:application/zip;base64," prefix
                resolve(base64data);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    const attachFiles = async (session, id, files) => {
        const zip = new JSZip();

        for(const f of files) {
            zip.file("productImage." + f.extension, f.data.replace(/^data:image\/[a-z]+;base64,/, ""), {base64: true});
        }

        const req = request.model("i_product")
            .id(id)
            .attachment(true);

        const blob = await zip.generateAsync({ type: "blob" });
        const data = await blobToBase64(blob);

        const url = req.buildRequest(env.API_URL) + "/zip";
        return HttpClient.client.post(url, {data}, api.auth(session));
    }

    builder.sendIt = async (session) => {
        const resp = await request.model("i_product")
            .data(getImportData(session))
            .post(session);

        if(builder.imgData) {
            const id = resp.id;
            await attachFiles(session, id, [builder.imgData])
        }

        await sendRequest(session, builder.reqData.name, builder.reqData.VendorProductNo);
        return "done";
    }

    return builder;
}

export default newProductRequest;
